
/*!
 * Main Js File
 * Funciones varias, como el manejo del ScrollToTop, mapas, links del menu cuando es onepage
 */

window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
})();

(function ($) {

    "use strict";

    var ruralApp = {
        backToTopItem: $('.back-to-top'),
        smoothScrollItem: $('.smooth-scroll'),
        options: {
            isOnePage: document.body.classList.contains('one_page') ? true : false,
            isFront: location.pathname == "/" || location.pathname == "/app_dev.php/" || location.pathname == "/app_dev.php"
        }
    };

    var headerFixedHeight = $('.navbar').outerHeight(true) || 0 + 10;

    if (ruralApp.options.isFront) {
        $('body').scrollspy({ target: '#main-nav', offset: headerFixedHeight });
    }

    var scrollTo = function () {
        var elem = this;
        event.preventDefault();
        //check if rural is one page
        if (ruralApp.options.isOnePage) {
            //if its one page, check if location is home or another page
            if (ruralApp.options.isFront) {
                //if its home page, complete normal smooth scroll to an anchor
                smoothScroll(elem);
            } else {
                //if its not home page, redirect to home page anchor
                var urlPath = location.pathname.indexOf("app_dev.php") != -1 ? "/app_dev.php/" : "/";
                window.location = urlPath + elem.hash;
                return;
            }
        } else {
            //if its not one page, complete normal smooth scroll to an anchor
            smoothScroll(elem);
        }
    };

    var smoothScroll = function (elem) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, '') == elem.pathname.replace(/^\//, '') && location.hostname == elem.hostname) {
            var target = $(elem.hash);
            target = target.length ? target : $('[name=' + elem.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - headerFixedHeight + 30
                }, 1000);
                return false;
            }
        }
    };

    ruralApp.init = function () {
        this.addListener();
    };

    ruralApp.addListener = function () {
        var self = this;
        window.onload = function () {
            self.smoothScrollItem.on('click', scrollTo);
        };

        this.backToTopItem.on('click', function (event) {
            smoothScroll(this);
        });

    };

    ruralApp.Flexslider = (function () {
        var _initFlex = function (elem, prop) {
            if (typeof $.flexslider === 'undefined') {
                return;
            }
            $(elem).flexslider(prop);
        }

        return {
            initFlex: function (elem, prop) {
                _initFlex(elem, prop);
            }
        }
    })();

    ruralApp.MagnificPopup = (function () {
        var _initMagnific = function (elem, prop) {
            if (typeof $.magnificPopup === 'undefined') {
                return;
            }
            $(elem).magnificPopup(prop);
        }

        return {
            initMagnific: function (elem, prop) {
                _initMagnific(elem, prop);
            }
        }
    })();

    ruralApp.Map = (function () {

        var map;

        // Config Zoom
        var zoomOut, zoomIn;

        // Makers, marker pin image, locations, center map
        var markers = [];
        var marker_image;
        var locations = [];
        var centerMap = { lat: '', long: '' };

        // Message widget
        var infoWindowHTML = '<div class=\"infowindow-content\">' +
            '<h5 class=\"infowindow-title\"> %infoTitle% </h5>' +
            '<p>%infoContent%</p></div>';

        var _initMap = function (elem, locationsLoaded, styledMap) {
            var $e = $(elem);

            //if element not exist, return

            if ($e.length == 0) {
                return;
            }

            //Default center
            centerMap.lat = parseFloat($e.attr('data-map-lat') || -32.522779);
            centerMap.long = parseFloat($e.attr('data-map-long') || -55.76583500000004);

            zoomOut = parseInt($e.attr('data-map-zoom-out') || 6);
            zoomIn = parseInt($e.attr('data-map-zoom-in') || 15);

            marker_image = $e.attr('data-marker-image') || '/bundles/grupoiterural/img/map-marker.png';

            locations = locationsLoaded;

            //Map start init
            var mapOptions = {
                center: new google.maps.LatLng(centerMap.lat, centerMap.long),
                zoom: zoomOut,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.DEFAULT,
                },
                disableDoubleClickZoom: false,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                },
                scaleControl: true,
                scrollwheel: false,
                streetViewControl: true,
                draggable: true,
                overviewMapControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,

                //color, lines, routes, water color
                styles: styledMap || []
            };

            map = new google.maps.Map($e.get(0), mapOptions);

            _createMarkers();
        };

        var _createMarkers = function () {
            locations.forEach(function (elem, index) {
                var marker = new google.maps.Marker({
                    name: elem[0],
                    position: elem[1],
                    map: map,
                    icon: marker_image
                });

                var infowindow = new google.maps.InfoWindow({
                    content: infoWindowHTML.replace('%infoTitle%', elem[2].title).replace('%infoContent%', elem[2].content)
                });

                markers.push(marker);

                _addListenerMarker(marker, infowindow);
            });
        };

        var _addListenerMarker = function (marker, infowindow) {
            marker.addListener('click', function () {
                map.setZoom(zoomIn);
                map.setCenter(marker.getPosition());
                infowindow.open(map, marker);
            });
        };


        // expose private Methods
        return {
          initMap: function (elem, options, styledMap) {
            _initMap(elem, options, styledMap);
          }
        };

    })();


    document.addEventListener('DOMContentLoaded', function () {
        //expose ruralApp globally
        window.ruralApp = ruralApp;

        ruralApp.init();

    }, false);

    $("img").unveil();

})(jQuery);

$(document).ready(function() {
    $('.openModalTab').click(function(e) {
        e.preventDefault();
        var tab = $(this).data('tab');

        $('#modal-login').modal('show');
        $('#modal-login').on('shown.bs.modal', function() {
            $('.nav-tabs a[href="#' + tab + '"]').tab('show');
        });
    });
});